// @flow
import React from 'react';
import {
  StyledLabel,
  StyledDiv,
  ScrollableTableContainer,
} from '@src/common-utils/styledComponents';

import { StaticTable } from './StaticTable';
import { Spacer } from './spacing/Spacer';

export const NotificationToastWithTable = ({
  message,
  width = '800px',
  tableContents,
  cellRenderers,
}) => {
  return (
    <StyledDiv width={width}>
      <StyledLabel style={{ lineHeight: '1.6', whiteSpace: 'pre-line', background: 'transparent' }}>
        {message}
      </StyledLabel>
      <Spacer y={10} />
      <ScrollableTableContainer>
        <StaticTable cellRenderers={cellRenderers} tableContents={tableContents} />
      </ScrollableTableContainer>
    </StyledDiv>
  );
};
